import { useState } from 'react'
import { Link } from 'react-router-dom'
import { AgentMemoryPanel, CreateMemoryDialog } from '@/components/projects'
import { useAgentDetailContext } from '@/hooks'

export function AgentMemoryPage() {
  const { projectId, agent, canManageMemory } = useAgentDetailContext()
  const [createOpen, setCreateOpen] = useState(false)

  if (!agent.memoryEnabled) {
    return (
      <div
        className="rounded-2xl border border-dashed border-border bg-table-row p-8 text-center text-sm text-muted-foreground"
        data-testid="agent-memory-disabled"
      >
        Memory is off for this agent. Turn it on in{' '}
        <Link to="../config" className="underline">Config → Memory Scope</Link> to let it remember facts between runs.
      </div>
    )
  }

  if (!canManageMemory) {
    return (
      <div
        className="rounded-2xl border border-dashed border-border bg-table-row p-8 text-center text-sm text-muted-foreground"
        data-testid="agent-memory-forbidden"
      >
        You need permission to edit agents before you can read what this one remembers.
      </div>
    )
  }

  return (
    <div data-testid="agent-memory-section">
      <AgentMemoryPanel projectId={projectId} agentId={agent.id} onCreateClick={() => setCreateOpen(true)} />
      <CreateMemoryDialog projectId={projectId} agentId={agent.id} open={createOpen} onOpenChange={setCreateOpen} />
    </div>
  )
}
